import { configureStore } from '@reduxjs/toolkit';

import languageReducer from './useLanguageStore';
import adminReducer from './useAdminStore';
import companyReducer from './useCompanyStore';
import HeirReducer from './useHeirStore';
import { applyCooperativeTranslations } from 'i18n';
import { isCooperativeCompany } from 'core/services/cooperative';

const store = configureStore({
	reducer: {
		language: languageReducer,
		admin: adminReducer,
		company: companyReducer,
		heir: HeirReducer,
	},
});

// cooperative societies use their own terminology across the platform
let isCooperative = false;
store.subscribe(() => {
	const isCompanyCooperative = isCooperativeCompany(store.getState().company);
	if (isCompanyCooperative !== isCooperative) {
		isCooperative = isCompanyCooperative;
		applyCooperativeTranslations(isCooperative);
	}
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
